export default __webpack_public_path__ + "static/sideRight-bea5d4f6e613ef204217c6e739805900.jpg";